import { render } from "./PartnerNoticeForm.vue?vue&type=template&id=a2010df0"
import script from "./PartnerNoticeForm.vue?vue&type=script&lang=js"
export * from "./PartnerNoticeForm.vue?vue&type=script&lang=js"

import "./PartnerNoticeForm.vue?vue&type=style&index=0&id=a2010df0&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__